import { defineStore } from 'pinia';
import { computed } from 'vue';
import { SINGLETON_KEY } from '#layers/base/public';
import { defineWorkspaceHydration } from '#layers/runtime/public';

/** The `/info` probe of a workspace runtime. */
export const workspaceInfoHydration = defineWorkspaceHydration((store) => store.WorkspaceInfo.query((q) => q.first({ key: SINGLETON_KEY })), { empty: null });

export const useWorkspaceInfoStore = defineStore('workspace-info', () => {
	const { data: info, isRefreshing, refresh: refreshInfo } = workspaceInfoHydration.use();

	/** Re-probes the active runtime; a failed probe keeps the last known state. */
	async function refresh() {
		try {
			await refreshInfo();
		}
		catch (error) {
			console.warn('[useWorkspaceInfoStore] /info probe failed; keeping last known state', error);
		}
	}

	return {
		refresh,
		aiEnabled: computed(() => info.value?.ai.enabled === true),
		loading: isRefreshing,
	};
});
